// import feature state here
import { provideState } from '@ngrx/store';
import { EnvironmentProviders } from '@angular/core';
import { irGeneratorFeature } from '@ps/ai-assistant-data-access';
import { authFeature } from '@ps/auth-data-access';
import { surveyFeature } from '@ps/survey-data-access';

export const STORE_FEATURES: EnvironmentProviders[] = [
  provideState(authFeature),
  provideState(surveyFeature),
  provideState(irGeneratorFeature),
];
